<template>
  <div class="tab">
    <h3>项目中期报告</h3>
    <div>
      <p>通过对已有国内外儿童青少年积极发展的综述和实证研究文献以及干预方案等进行系统性分析，确定了本课题的基本理论指导为发展心理学元理论“关系-发展-系统模型”，并发现了已有研究中存在的局限，此环节为本课题建构基于中国文化背景下的青少年积极发展结构、内涵和测量指标奠定了良好的理论和方法学基础。通过基于五大人群112人的深度个别访谈方法，以及对文本进行全面编码，确定了中国青少年积极发展的四维结构（能力、自我价值、联结和品格）、内涵及理论框架。</p>
      <p>遵循科学的心理学问卷与测量工具编制程序，课题组基于质性编码及中国优秀传统文化和时代发展的需要，已完成了本课题的核心成果之一《中国青少年积极发展问卷》的编制，并建立了针对我国儿童青少年积极发展状况的测查工具库，建构了我国儿童青少年积极发展结果指标体系以及影响积极发展结果的个体和环境促进性因素指标体系。</p>
      <p>在全国范围内分层多阶段取样，考察我国流动儿童、留守儿童、农村儿童和城市儿童的积极发展特点及各重要影响性因素的作用。课题组目前已经完成全国性的调查，将继续对这些处境不利儿童开展多次追踪调查，并建构促进流动背景下处境不利儿童积极发展的体系。</p>
      <a :href="src" download="中期进展报告.pdf">附：中期进展报告.pdf</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "report",
  data() {
    return {
      src:[require('../../assets/pdf/CPYDS.pdf')]
    };
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
  /* @import '../assets/style/child.css'; */
</style>
<style scoped>
.tab>div>a{
  font-size: 16px;
  text-decoration: underline;
  color: #740015
}
</style>



// WEBPACK FOOTER //
// src/components/tabs/report.vue